import { initialize as initializeAbtProvider, getABTProvider } from './statsig'
import { initializeStatsigWithCountry } from './initializer'

export { initializeAbtProvider, initializeStatsigWithCountry }

export default {
  install(Vue) {
    const service = getABTProvider()
    Vue.prototype.$abtProvider = service
  },
}
